import {useQuery, UseQueryResult} from '@tanstack/react-query'

import {QueryKeyName, getActionsBySectionId} from '../../common/backend'
import {ActionItem} from '../../types'
import {usePlantUpmId} from '../usePlantUpmIdContext'

export const useSectionActions = (sectionId: string): UseQueryResult<ActionItem[]> => {
  const plantId = usePlantUpmId()

  return useQuery({
    queryKey: [QueryKeyName.GetActionItems, plantId, sectionId],
    queryFn: async () => {
      return await getActionsBySectionId({plantId, sectionId})
    }
  })
}
